import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';



export interface ResultFeedbackDialogProps {
    successDialogOpen: boolean;
    onClose: () => void;
    title: string;
    icon: React.ReactNode;
    description: string;
    leftButtonText?: string;
    rightButtonText?: string;
    onLeftAction?: () => void;
    onRightAction?: ()=> void;
}

const ResultFeedbackDialog = (props: ResultFeedbackDialogProps) => {
    const { successDialogOpen, onClose, title, icon, description, leftButtonText, rightButtonText, onLeftAction, onRightAction} = props;



    const handleClose = () => {
        onClose();
    }


    return (
        <Dialog
            open={successDialogOpen}
            onClose={handleClose}
            PaperProps={{ sx: { padding: '24px', width: '500px' } }}
        >
            <IconButton
                sx={{
                    position: 'absolute',
                    top: '20px',
                    marginLeft: '470px',
                }} onClick={handleClose}>
                <CloseOutlinedIcon />
            </IconButton>
            <DialogTitle sx={{ alignItems: 'center', marginTop: '25px', fontWeight: 600, gap: 1.5, display: 'flex', flexDirection: 'column', }}>
                {icon}
                {title}
            </DialogTitle>
            <DialogContent sx={{ textAlign: 'center' }}>
                <DialogContentText>
                    {description}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                {onLeftAction && leftButtonText &&
                    <Button
                        size="large"
                        data-testid="dialog-discard"
                        onClick={onLeftAction}
                    >
                        {leftButtonText}
                    </Button>
                }
                {onRightAction && rightButtonText &&
                    <Button
                        size="large"
                        color="primary"
                        variant="contained"
                        data-testid="dialog-send"
                        onClick={onRightAction}
                        autoFocus
                    >
                        {rightButtonText}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
};

export default ResultFeedbackDialog;
